import { BonusReportForPlaceTranslations } from "./bonus-report-for-place-pt-br";

export const BONUS_REPORT_FOR_PLACE_FR_FR: BonusReportForPlaceTranslations = {
	title: "Prime",
};
